import cx from 'classnames';

import { HOME_PAGE_RESOURCES } from '../../constants/homePageStatic';

import styles from '../../styles/homePage/resourceList.scss';
import Question from './question';

const ResourceList = () => (
  <div className={cx(styles['resource-list'])}>
    <h3 className={cx(styles.title, 'text-center')}>
      {HOME_PAGE_RESOURCES.title}
    </h3>
    <h5 className={cx(styles['sub-title'], 'text-center')}>
      {HOME_PAGE_RESOURCES.subTitle}
    </h5>
    <ul className={styles.list}>
      {(HOME_PAGE_RESOURCES.links || []).map(
        (linkObj: any, index: number, links: any) => (
          <Question
            styles={styles}
            linkObj={linkObj}
            key={linkObj.question}
            index={index}
            last={index + 1 === links.length}
            collapsed={true}
          />
        )
      )}
    </ul>
    <div className="lil-mb-12 lil-mt-10 lil-text-center">
      <a
        href="https://assets1.cleartax-cdn.com/clearsave/images/1648028018_faqs_investments.pdf"
        className="font--blue hollow-invest__uQjvi bold"
        target="_blank"
      >
        Download FAQs
      </a>
    </div>
  </div>
);

export default ResourceList;



// WEBPACK FOOTER //
// ./components/homePage/resourceList.tsx